module.exports = __webpack_public_path__ + "img/office.b431edc6.jpg";